module.exports = __webpack_public_path__ + "img/nintendo2.c088c18e.png";